module.exports = "/static/assets/3f0a747ac8a8081f4cb1a48e69d43af7.png";